module.exports = __webpack_public_path__ + "static/media/foo_chuan_sheng.94c068ce.jpg";